import { WordPressTemplate } from '@faustwp/core'
import { getConsolidatedStaticProps } from '../utilities/getStaticProps'

export default function WordPressPage(props) {
  return <WordPressTemplate {...props} />
}

export const getStaticProps = getConsolidatedStaticProps

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  }
}
